import { render, staticRenderFns } from "./VoucherOrders.vue?vue&type=template&id=00caca5e&"
import script from "./VoucherOrders.vue?vue&type=script&lang=js&"
export * from "./VoucherOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports